import React, { useState } from "react";
import { db } from "../../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import styles from "./RelatedVideoUploadForm.module.css";

const RelatedVideoUploadForm = ({ setVideos }) => {
  const [title, setTitle] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [hashtags, setHashtags] = useState("");
  const [loading, setLoading] = useState(false);

  // 유튜브 썸네일 URL 자동 추출
  const getYoutubeThumbnail = (url) => {
    const videoId = url.split("v=")[1]?.split("&")[0]; // 유튜브 URL에서 ID 추출
    return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !videoUrl) {
      alert("제목과 영상 URL을 입력하세요!");
      return;
    }

    setLoading(true);
    try {
      const newVideo = {
        title,
        videoUrl,
        thumbnail: getYoutubeThumbnail(videoUrl),
        hashtags: hashtags.split(",").map((tag) => tag.trim()), // 해시태그 배열 변환
        createdAt: serverTimestamp(),
      };

      const docRef = await addDoc(collection(db, "relatedVideos"), newVideo);
      setVideos((prev) => [{ id: docRef.id, ...newVideo }, ...prev]);

      setTitle("");
      setVideoUrl("");
      setHashtags("");
    } catch (error) {
      console.error("🔥 관련 영상 업로드 실패:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="영상 제목"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="유튜브 영상 URL"
        value={videoUrl}
        onChange={(e) => setVideoUrl(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="해시태그 (쉼표로 구분)"
        value={hashtags}
        onChange={(e) => setHashtags(e.target.value)}
      />
      <button type="submit" disabled={loading}>
        {loading ? "업로드 중..." : "관련 영상 추가"}
      </button>
    </form>
  );
};

export default RelatedVideoUploadForm;
